// Same seniority-mix chart the productized Status Portal renders. Declared here
// rather than imported from features/enrollment/StatusPortal so the experiment
// carries no dependency on that feature.
export const SENIORITY_MIX_IMG_SRC =
  'https://static.masterclass.com/executive-enrollment-status-chart-v5.svg'
